
import { Component, Inject, Vue } from 'vue-property-decorator';

import { DesignerStateProvider } from '../../designer.provider';
import { DesignerElementTypes } from '../../designer.enum';
import { FileProvider } from '@/shared/providers/files.provider';

@Component({
  name: 'ed-designer-elements',
})
export default class EdDesignerElements extends Vue {
  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  @Inject()
  readonly FileProvider: FileProvider;

  readonly DesignerElementTypes = DesignerElementTypes;

  onSelectElement(type: DesignerElementTypes, meta?: any) {
    this.DesignerStateProvider.addElement(type, meta);
  }

  async selectImage(event) {
    const image = event?.target?.files?.[0];
    const imageCompressed = await this.FileProvider.compressImage(
      image,
      this.DesignerStateProvider.maxMBImageToImport,
      this.DesignerStateProvider.containerHeight,
      0.2,
    );

    if (imageCompressed) {
      const imageBase64 = await this.FileProvider.transformImageToBase64(imageCompressed);

      this.onSelectElement(DesignerElementTypes.Image, { src: imageBase64 });
      event.target.value = '';
    }
  }
}
